// extracted by mini-css-extract-plugin
export var marginNegative = "_63-5 _63-3 _63-1";
export var marginPositive = "_63-4 _63-3 _63-1";
export var modalContent = "_63-6";
export var samplesTable = "_63-8";
export var samplesTableContainer = "_63-7";
export var statBox = "_63-a";
export var tableCell = "_63-1";
export var tableCellCenter = "_63-2 _63-1";
export var tableCellRight = "_63-3 _63-1";
export var tableHeader = "_63-0";
export var trackingNumber = "_63-9";